/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import SuccessIcon from '@atlaskit/icon/glyph/editor/success';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { G400, N200, R400 } from '@atlaskit/theme/colors';
import { gridSize } from '@atlaskit/theme/constants';
import { h200 } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
const errorColor = css`
  color: ${token('color.text.danger', R400)};
`;
const validColor = css`
  color: ${token('color.text.success', G400)};
`;

const messageStyle = props => css`
  ${h200(props)} font-weight: normal;
  color: ${token('color.text.subtlest', N200)};
  margin-top: ${gridSize() / 2}px;
  display: flex;
  justify-content: baseline;
`;

const iconWrapperStyle = css`
  display: flex;
  margin-right: 4px;
`;
export const HelperMessage = ({
  children
}) => jsx("div", {
  css: messageStyle
}, children);
export const ErrorMessage = ({
  children
}) => jsx("div", {
  css: theme => {
    return [messageStyle(theme), errorColor];
  }
}, jsx("span", {
  css: iconWrapperStyle
}, jsx(ErrorIcon, {
  size: "small",
  label: "error",
  "aria-label": "error"
})), children);
export const ValidMessage = ({
  children
}) => jsx("div", {
  css: theme => {
    return [messageStyle(theme), validColor];
  }
}, jsx("span", {
  css: iconWrapperStyle
}, jsx(SuccessIcon, {
  size: "small",
  label: "success"
})), children);